import FuelPrimax from "./FuelPrimax";

export default FuelPrimax;
